<script>
import {Loading} from "vant";
import qs from 'qs';
import axios from "axios";
import DateFromTo from "../components/DateFromTo.vue";
import SearchButton from '../components/SearchButton.vue';
export default {
  components: {
    [Loading.name]: Loading,
    DateFromTo,
    SearchButton,
  },
  data() {
    return {
      url: localStorage.getItem("url"),
      bearer: localStorage.getItem("bearer"),
      onLine: navigator.onLine,
      animated: false,
      addFontKhmer: false,
      empty: false,
      clearData: 1,
      loading: false,
      bus: true,
      boat: false,
      show: false,
      showPicker: false,
      info: [],
      active: 0,
      search: "",
      destinationTo: localStorage.getItem('destinationTo'),
      destinationToId: localStorage.getItem('destinationToId'),
      destinationFrom: localStorage.getItem('destinationFrom'),
      destinationFromid: localStorage.getItem('destinationFromId'),
      destinationFromSearch: "",
      inputSearchDeparture: false,
      cancelDepart: false,
      destinationToSearch: "",
      inputSearchDestination: false,
      cancelDestination: false,
      activeIndexDep: "",
      activeIndexDes: "",
      alertDest: false,
      alertDepart: false,
      showInternetDeparture: false,
      showInternetDepartureHome: false,
      InternetDestination: false,
      cacheDestFrom: [],
      cacheDestTo: [],
      profile: {
        id: "",
        firstName: "Passenger",
        middleName: "",
        lastName: "",
        fullName: "",
        sex: "",
        dobShort: "",
        nationality: "",
        phone: "", // +85568203911
        email: "",
        lang: "en", // en, kh,
      },
      isCheckPopup: 0,
      exitApp: false,
      lengthName: false,
    };
  },

  created() {
    // set bar title
    this.$bridge.callHandler("setBarTitle", { title: "VET Express", bgColor: "#de5d0a",color: "#ffffff"});
    if(localStorage.getItem("clearData") == null || localStorage.getItem("clearData") == "1"){
      this.clearStorage();
      localStorage.setItem("clearData", '0');
    }
    // Set Bus Type
    this.activeTap();

    if(localStorage.getItem("userphone") != null) {
      this.profile.phone = localStorage.getItem("userphone");
    }
    if(localStorage.getItem("username") != null) {
      this.profile.firstName = localStorage.getItem("username");
    }
    if(localStorage.getItem("lastname") != null) {
      this.profile.lastName = localStorage.getItem("lastname");
    }
    if(localStorage.getItem("fullName") != null) {
      this.profile.fullName = localStorage.getItem("fullName").slice(0,17);
    }
    if(localStorage.getItem("sex") != null) {
      this.profile.sex = localStorage.getItem("sex");
    }
    if(localStorage.getItem("nationality") != null) {
      this.profile.nationality = localStorage.getItem("nationality");
    }
    if(!this.onLine) {
      this.showInternetDepartureHome = true;
    }
    if(this.$i18n.locale == "en") {
      this.addFontKhmer = false;
    }else {
      this.addFontKhmer = true;
    }
    localStorage.setItem("dateDialog", 0);
    if((this.profile.firstName + this.profile.lastName).length>50){
      this.lengthName = false;
    }else{
      this.lengthName = true;
    }
    if(localStorage.getItem('destinationFromId') != null || localStorage.getItem('destinationFromId') == ""){
      this.activeIndexDep = localStorage.getItem('destinationFromId');
    }else{
      this.activeIndexDep = "";
    }
    if(localStorage.getItem('destinationToId') != null || localStorage.getItem('destinationToId') == ""){
      this.activeIndexDes = localStorage.getItem('destinationToId');
    }else{
      this.activeIndexDes = "";
    }

  },
  mounted() {
    window.onpopstate = () => {
      if(this.isCheckPopup == 1 || localStorage.getItem("dateDialog") == 1){
        if(this.isCheckPopup == 1){
          setTimeout(() => {
            this.closedShowPopup();
            this.closedShowPopupTo();
          }, 300);
        } 
        if(localStorage.getItem("dateDialog") == 1) {
          setTimeout(() => {  
            this.$refs.dateComponent.closedPoDate();
            this.$refs.dateComponent.closedPoDateTo();
          }, 300);
        }
      } else {
        setTimeout(() => {
          this.handleCloseApp();
        }, 300);
        // this.$bridge.callHandler("closeApp").then(() => {});
      }
    };

    // get profile from native app
    if(localStorage.getItem('userphone') != null || localStorage.getItem('userphone') == "" || localStorage.getItem('username') != null || localStorage.getItem('username') == ""){
      this.$bridge.callHandler("getProfile").then((data) => {
        this.profile = data;
        // Set User Phone Default
        localStorage.setItem('userphone', this.profile.phone);
        localStorage.setItem('username', this.profile.firstName);
        localStorage.setItem('lastname', this.profile.lastName);
        localStorage.setItem('fullName', this.profile.fullName);
        localStorage.setItem('sex', this.profile.sex);
        localStorage.setItem('nationality', this.profile.nationality);
      }); 
    }
  },
  watch: {
    destinationFromSearch() {
       if(this.cacheDestFrom.length > 0){
        let resultList = this.cacheDestFrom;
        let resultDest = [];
        for(let i = 0; i < resultList.length; i++) {
          let destName = resultList[i].name.toLowerCase();
          let match = destName.match(this.destinationFromSearch.toLowerCase());
          if(match != null){
            resultDest.push({id: resultList[i].id, name: resultList[i].name});
          }
        }
        this.info = resultDest;
        if(this.destinationFromSearch != "" && this.destinationFromSearch != null) {
          this.cancelDepart = true;
        } else {
          this.cancelDepart = false;
        }
        // Check Data Display Length Show Empty or Not
        if(this.info.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      }
    },
    destinationToSearch() {
      if(this.cacheDestTo.length > 0){
        let resultList = this.cacheDestTo;
        let resultDest = [];
        if(resultList != null){
          for(let i = 0; i < resultList.length; i++) {
              let destName = resultList[i].name.toLowerCase();
              let match = destName.match(this.destinationToSearch.toLowerCase());
              if(match != null){
                resultDest.push({id: resultList[i].id, name: resultList[i].name});
              }
          }
          this.info = resultDest;
          if(this.destinationToSearch != "" && this.destinationToSearch != null) {
            this.cancelDestination = true;
          }else{
            this.cancelDestination = false;
          }
        }
        // Check Data Display Length Show Empty or Not
        if(this.info.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      }
    }
  },
  methods: {
    handleCloseApp() {
      this.exitApp = true;
    },
    onCancel() {
      this.exitApp = false;
    },
    clickLeave() {
      this.$bridge.callHandler("closeApp").then(() => {}).catch(() => {});
    },
    activeTap() {
      if(localStorage.getItem('types') == null || localStorage.getItem('types') == '') {
        localStorage.setItem('types', 1);
        this.active = 0;
      }else if(localStorage.getItem('types') == 1){
        localStorage.setItem('types', 1);
        this.active = 0;
      }else{
        localStorage.setItem('types', 2);
        this.active = 1;
      }
    },
    closedInternetDepartureh(){
      this.$bridge.callHandler("closeApp").then(() => {});
    },
    closedInternetDeparture() {
      this.showInternetDeparture = false;
      this.getDataDestinationFrom();
    },
    
    closedDestinations() {
      this.InternetDestination = false;
      this.getDataDestinationTo();
    },

    showPopup() {
      this.isCheckPopup = 1;
      this.show = true;
      this.destinationFromSearch = "";
      this.cancelDepart = false;
      this.getDataDestinationFrom();
    },

    closedShowPopup() {
      this.isCheckPopup = 0;
      this.show = false;
    },

    closedShowPopupTo() {
      this.isCheckPopup = 0;
      this.showPicker = false;
    },

    showPopupTo() {
      this.isCheckPopup = 1;
      this.showPicker = true;
      this.destinationToSearch = "";
      this.cancelDestination = false;
      this.getDataDestinationTo();
    },
    onClickChangeBusType() {
      this.activeIndexDep = false,
      this.activeIndexDes = false,
      this.bus = true; 
      // Reset Destination
      this.destinationFrom = '';
      this.destinationTo   = '';
      localStorage.removeItem('destinationFrom');
      localStorage.removeItem('destinationFromId');
      localStorage.removeItem('destinationTo');
      localStorage.removeItem('destinationToId');
      // Reset Date
      this.$refs.dateComponent.clearDateTo();
      if(this.active == 0) {
        localStorage.setItem('types', 1);
      }else{
        localStorage.setItem('types', 2);
      }
    },

    onConfirmFrom(destinationFromName, destinationFromId) {
      this.destinationFrom = destinationFromName;
      this.destinationFromid = destinationFromId;
      this.destinationTo = '';
      localStorage.removeItem('destinationTo');
      localStorage.removeItem('destinationToId');
      localStorage.setItem('destinationFrom', this.destinationFrom);
      localStorage.setItem('destinationFromId', this.destinationFromid);
      this.show = false;   
      this.activeIndexDep = destinationFromId;
      this.activeIndexDes = "";
    },

    onConfirmTo(destinationToName, destinationToId) {
      this.destinationTo = destinationToName;
      this.destinationToid = destinationToId;
      this.showPicker = false;
      localStorage.setItem('destinationTo', this.destinationTo);
      localStorage.setItem('destinationToId', this.destinationToid);
      this.activeIndexDes = destinationToId;
    },

    goToViewTicket() {
      localStorage.setItem("homepage", "0");
      localStorage.setItem("clearData", '1');
      this.$router.push("/show-ticket");
    },
    onClickDestination() {
      if(this.destinationFrom == '' || this.destinationFrom == null) {
        this.alertDepart = true;
      }else{
        this.showPopupTo();
      }
    },

    onSwitchDestination(){
      this.animated = true
      setTimeout(() => {
        this.animated = false
      }, 1000)
      if(this.destinationFrom == '' || this.destinationFrom == null && this.destinationTo == '' || this.destinationTo == null) {
        this.alertDest = true;
      }else{
        if(this.destinationFrom != '' && this.destinationTo != '') {
          const tempId = this.destinationToId;
          const tempName = this.destinationTo;
          this.destinationToId = this.destinationFromid;
          this.destinationTo =  this.destinationFrom;  
          this.destinationFromid = tempId;
          this.destinationFrom   = tempName;
          // Change Index Departure and Destination
          let indexDepart = this.activeIndexDep;
          let indexDest   = this.activeIndexDes;
          this.activeIndexDep = indexDest;
          this.activeIndexDes = indexDepart;
        }else {
          this.alertDest = true;
        }
      }
    },
    cancelDeparts() {
      this.destinationFromSearch = "";
      this.cancelDepart = false;
    },

    cancelDestinations() {
      this.destinationToSearch = "";
      this.cancelDestination = false;
    },

    // Get Date From Api DestinationFrom
    async getDataDestinationFrom() {
      const data = {'searchText': this.search,'type': localStorage.getItem('types')};
      const url = this.url + `destination/from`;
      this.inputSearchDeparture = false;
      let config = {
        method: "POST",
        headers: {
          "Authorization": this.bearer,
          "Content-Type":"application/x-www-form-urlencoded; charset=UTF-8",
          "accept": "*/*",
        },
        data: qs.stringify(data),
        url
      };
      this.loading = true;
      axios(config).then(response => {
          localStorage.setItem("destinationFromList", "");
          this.loading = false;
          this.inputSearchDeparture = true;
          if(response.status == 200){
            if(response.data.header.result == true && response.data.header.statusCode == 200) {
              if(response.data.body == 0) {
                this.empty = true;
              }else{
                this.empty = false;
              }
              this.info = response.data.body;
              this.cacheDestFrom = response.data.body;
            } else {
              this.errored = true
            }
          }
      }).catch(error => {
        this.showInternetDeparture = true;
        console.log(error);
      })
    },

    // Get Date From Api Destination To
    async getDataDestinationTo() {
      const data = {'fromId': this.destinationFromid,'searchText': this.search,'type': localStorage.getItem('types')};
      const url =  this.url + `destination/to`;
      this.inputSearchDestination = false;
      let config = {
        method: "POST",
        headers: {
          "Authorization": this.bearer,
          "Content-Type":"application/x-www-form-urlencoded; charset=UTF-8",
          "accept": "*/*",
        },
        data: qs.stringify(data),
        url
      };
      this.loading = true;
      axios(config).then(response => {
          localStorage.setItem("destinationToList", "");
          this.loading = false;
          this.inputSearchDestination = true;
          if(response.status == 200){
            if(response.data.header.result == true && response.data.header.statusCode == 200) {
              if(response.data.body == 0) {
                this.empty = true;
              }else{
                this.empty = false;
              }
              this.info = response.data.body;
              this.cacheDestTo = response.data.body;
            }else{
              this.errored = true
            }
          }

      }).catch(error => {
        this.InternetDestination = true;
        console.log(error);
      })
    },

    clearStorage () {
      localStorage.removeItem("clearData");
      localStorage.removeItem('journeyid');
      localStorage.removeItem('price');
      localStorage.removeItem('departure');
      localStorage.removeItem('seat');
      localStorage.removeItem('seatlabel');
      localStorage.removeItem('journeyidback');
      localStorage.removeItem('departureback');
      localStorage.removeItem('priceback');
      localStorage.removeItem('seatback');
      localStorage.removeItem('seatlabelback');
      localStorage.removeItem('gender');
      localStorage.removeItem('genderBack');
      localStorage.removeItem('total');
      localStorage.removeItem('transactionId');
      localStorage.removeItem('boardingpoint');
      localStorage.removeItem('dropoff');
      localStorage.removeItem('boardingpointB');
      localStorage.removeItem('dropoffB');
      localStorage.removeItem('arrivalDate');
      localStorage.removeItem('arrivalDateBack');
      localStorage.removeItem('reloadTicket');
      localStorage.removeItem('ticketSuccessId');
      localStorage.removeItem('idbooking');
      localStorage.removeItem('boardingpointBId');
      localStorage.removeItem('bPointid');
      localStorage.removeItem('dropoffId');
      localStorage.removeItem('dropoffBId');

    },

    closedDestination() {
      this.alertDest = false;
    },

    closedDeparture() {
      this.alertDepart = false;
    },

  },
};
</script>
<template>
  <!-- Khmer  -->
  <div class="container-home">
    <!-- Slider -->
    <div class="container-df-name-slide">
      <div class="welcome-name">
        <div :class="{langKh: addFontKhmer}" style="font-weight: 400;color: #FFF;text-transform: capitalize;font-size: 14px;">{{ $t('message.welcome') }}</div>
        <div>
          <div class="capitalize" v-if="lengthName">
            {{this.profile.firstName}} {{this.profile.lastName}}
          </div>
          <div v-else class="capitalize" style="font-size:16px">
            {{this.profile.firstName}} {{this.profile.lastName}}
          </div>
        </div>
      </div>
      <div class="slider-image">
        <div class="slide-boat" v-if="active">
          <img :src="require('@/assets/carousel/boat.svg')" alt="">
        </div>
        <div class="slide-bus" v-else>
          <img :src="require('@/assets/carousel/bus.svg')" alt="">
        </div>
      </div>
    </div>
    <!-- Tab -->
    <div class="section-continer">
      <div class="custom-tab" style="border-top-left-radius: 20px;border-top-right-radius: 20px;">
        <van-tabs v-model:active="active" @click-tab="onClickChangeBusType()">
          <van-tab><template #title><p :class="{langKh: addFontKhmer, khFont: addFontKhmer}">{{$t('message.bus')}}</p></template></van-tab>
          <van-tab><template #title><p :class="{langKh: addFontKhmer, khFont: addFontKhmer}">{{$t('message.speedBoat')}}</p></template></van-tab>
        </van-tabs>
      </div>
    </div>
    <!-- Form -->
    <div class="custom-form">
      <div class="form-select-f">
        <input type="text" readonly="" v-model="destinationFrom" @click="showPopup" :placeholder="$t('message.selectDeparture')" :class="{langKh: addFontKhmer}" class="form-select-from">
        <div class="from-img">
          <span :class="{langKh: addFontKhmer}">{{$t('message.from')}}</span>
          <img :src="require('@/assets/ic_point_add.svg')" alt="">
        </div>
      </div>
      <div class="form-select-t">
        <input type="text" readonly="" v-model="destinationTo" @click="onClickDestination" :placeholder="$t('message.selectDestination')" :class="{langKh: addFontKhmer}" class="form-select-to">
        <div class="to-img">
          <span :class="{langKh: addFontKhmer}">{{$t('message.to')}}</span>
          <img :src="require('@/assets/ic_point_add.svg')" alt="">
        </div>
      </div>
      <font-awesome-icon @click="onSwitchDestination" :class="{animation: animated }" icon="fa-solid fa-rotate" style="position: absolute;top: 78px;right: 40px;background: #FFF;color: #de5d0a; padding-left: 3px; padding-right: 3px; font-weight: bold;font-size: 20px;"/>
      <DateFromTo ref="dateComponent" />
      <SearchButton />
    </div>
    <!-- popup -->
    <van-popup style="border-top-left-radius: 25px;border-top-right-radius: 25px;" v-model:show="show" position="bottom" :style="{ height: '90%' }">
      <div style="padding-bottom: 10px;box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;position: fixed;width: 100%;background: #FFF;border-top-left-radius: 10px;border-top-right-radius: 10px;">
        <div style="position: relative;">
          <div class="selectD" :class="{langKh: addFontKhmer}">{{$t('message.selectDeparture')}}</div>
          <div class="closedPo" @click="closedShowPopup()" style="position: absolute;top: 0;font-size: 20px;color:#c8c9cc">
            <van-icon name="cross" />
          </div>
        </div>
        <div v-if="inputSearchDeparture" style="border:1px solid #f2f3f5;margin: 10px 18px 0px 11px;padding: 10px;border-radius: 8px;display: flex;height: 43px;padding-left: 10px;padding-right: 10px;align-items: center;background: #f2f3f5;">
          <font-awesome-icon icon="fa-solid fa-magnifying-glass" style="width: 10%;color:#8f8181;" />
          <input type="text" :value='destinationFromSearch' @input='evt=>destinationFromSearch=evt.target.value' show-action :class="{langKh: addFontKhmer}" :placeholder="$t('message.search')" autocomplete="off" style="width: 85%;border: none;background: #f2f3f5;" />
          <font-awesome-icon @click="cancelDeparts()" icon="fa-solid fa-xmark" v-if="cancelDepart" style="width: 5%;color:#8f8181;" />
        </div>
      </div>
      <div class="container_data" style="margin-top: 105px;">
        <div v-if="empty" style="color: #8e8e9d;text-align: center;position: fixed;width: 100%;height: 60%;display: flex;justify-content: center;align-items: center;">
          <p :class="{langKh: addFontKhmer}">{{$t('message.noDepartureFound')}}</p>
        </div>
        <div>
          <div>
            <div v-if="loading" class="data-loading" style="text-align: center;position: fixed;width: 100%;height: 60%;display: flex;justify-content: center;align-items: center;">
              <van-loading size="35" color="#de5d0a" />
            </div>
            <div v-else class="list-data listDepartureData" v-for="getData in info" :key="getData.id">
              <div style="padding-right: 2px;">
                <p @click="onConfirmFrom(destinationFromName = getData.name, destinationFromId = getData.id)" :class="{ activeDeparture: getData.id === activeIndexDep}">{{ getData.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showInternetDeparture">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.msgInternet')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedInternetDeparture" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                    </div>
                </button>
            </div>
        </div>
      </div>
    </van-popup>
    <van-popup style="border-top-left-radius: 25px;border-top-right-radius: 25px;" v-model:show="showPicker" position="bottom" :style="{ height: '90%' }">
      <div style="padding-bottom: 10px;box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;position: fixed;width: 100%;background: #FFF;border-top-left-radius: 10px;border-top-right-radius: 10px;">
        <div style="position: relative;">
          <div class="selectD" :class="{langKh: addFontKhmer}">{{$t('message.selectDestination')}}</div>
           <div class="closedPo" @click="closedShowPopupTo()" style="position: absolute;top: 0;font-size: 20px;color:#c8c9cc">
            <van-icon name="cross" />
          </div>
        </div>
         <div v-if="inputSearchDestination" style="border:1px solid #f2f3f5;margin: 10px 18px 0px 11px;padding: 10px;border-radius: 8px;display: flex;height: 43px;padding-left: 10px;padding-right: 10px;align-items: center;background: #f2f3f5;">
          <font-awesome-icon icon="fa-solid fa-magnifying-glass" style="width: 10%;color:#8f8181;" />
          <input type="text" :value='destinationToSearch' @input='evt=>destinationToSearch=evt.target.value' :placeholder="$t('message.search')" :class="{langKh: addFontKhmer}" style="width: 85%;border: none;background: #f2f3f5;" />
          <font-awesome-icon @click="cancelDestinations()" icon="fa-solid fa-xmark" v-if="cancelDestination" style="width: 5%;color:#8f8181;" />
        </div>
      </div>
      <div class="container_data" style="margin-top: 105px;">
        <div v-if="empty" style="color: #8e8e9d;text-align: center;position: fixed;width: 100%;height: 60%;display: flex;justify-content: center;align-items: center;">
          <p :class="{langKh: addFontKhmer}">{{$t('message.noDestinationFound')}}</p>
        </div>
        <div>
          <div>
            <div v-if="loading" class="data-loading" style="text-align: center;position: fixed;width: 100%;height: 60%;display: flex;justify-content: center;align-items: center;">
              <van-loading size="35" color="#de5d0a" />
            </div>
            <div v-else class="list-data" v-for="getData in info" :key="getData.id">
              <p @click="onConfirmTo(destinationToName = getData.name, destinationToId = getData.id)" :class="{activeDeparture: getData.id === activeIndexDes}">{{ getData.name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="InternetDestination">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.msgInternet')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedDestinations" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                    </div>
                </button>
            </div>
        </div>
      </div>
    </van-popup>
    <div style="margin-top: 25px;text-align: center;">
      <p style="color: #A5A5A5;font-size: 14px;font-weight: 400;">App Version: 2.29</p>
    </div>
    <div class="custom-tab-bar">
        <div class="home_page">
          <font-awesome-icon icon="fa-solid fa-house" style="color: #de5d0a;" />
          <p :class="{langKh: addFontKhmer}" style="font-size: 13px;color: #de5d0a;">{{$t('message.home')}}</p>
        </div>
        <div class="my_booking_page" @click="goToViewTicket()">
          <font-awesome-icon icon="fa-solid fa-store" />
          <p :class="{langKh: addFontKhmer}" style="font-size: 13px;">{{$t('message.myBooking')}}</p>
        </div>
    </div>
    <!-- alert dialog -->
    <div v-if="alertDest">
      <div class="van-overlay" style="z-index: 2001;"></div>
      <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
          <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
          <div class="van-dialog__content">
              <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.plSelectDestination')}}</div>
          </div>
          <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
              <button type="button" @click="closedDestination" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                  <div class="van-button__content">
                      <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                  </div>
              </button>
          </div>
      </div>
    </div>
    <div v-if="alertDepart">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.plSelectDeparture')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedDeparture" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
    <div v-if="showInternetDepartureHome">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.msgInternet')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedInternetDepartureh" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
    <div v-if="exitApp">
      <div class="van-overlay" style="z-index: 2001;"></div>
      <div class="van-popup van-popup--center van-dialog" role="dialog" tabindex="0" aria-labelledby="VET EXPRESS" style="z-index: 2001;">
          <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information') }}</div>
          <div class="van-dialog__content">
              <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.exitApp') }}</div>
          </div>
          <div class="van-hairline--top van-dialog__footer">
              <button type="button" @click="onCancel()" class="van-button van-button--default van-button--large van-dialog__cancel">
                  <div class="van-button__content">
                      <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.no') }}</span>
                  </div>
              </button>
              <button type="button" @click="clickLeave()" class="van-button van-button--default van-button--large van-dialog__confirm van-hairline--left">
                  <div class="van-button__content">
                      <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.exit') }}</span>
                  </div>
              </button>
          </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  .container-home {
    margin: 0px;
    width: 100%;
    height: auto;
  }
  .container-home .container-df-name-slide {
    background: #de5d0a;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 115px;
  }
  .container-home .container-df-name-slide .welcome-name {
    width: 70%;
    padding: 10px 10px 0px 15px;
    height: 100%;
  }
  .container-home .container-df-name-slide .welcome-name .capitalize {
    line-height: 1.4;
    font-weight: 500;
    width: 100%;
    color: #FFF;
    font-size: 18px;
    text-transform: capitalize !important;
  }
  .container-home .container-df-name-slide .welcome-name span {
    letter-spacing: 1px;
    color: #FFF;
  }
  .container-home .container-df-name-slide .slider-image {
    height: 100%;
    width: 30%;
  }
  .container-home .container-df-name-slide .slider-image .slide-bus {
    text-align: end;
    padding-right: 15px;
  }
  .container-home .container-df-name-slide .slider-image .slide-bus img {
    width: 90px;
  }
  .container-home .container-df-name-slide .slider-image .slide-boat {
    text-align: end;
    padding-right: 15px;
  }
  .container-home .container-df-name-slide .slider-image .slide-boat img {
    width: 90px;
  }
  .section-continer {
    border: 1px solid #FFF;
    background: #FFF;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    margin-top: -18px;
    padding-top: 0px;
    width: 100%;
  }
  .custom-form {
    width: 100%;
    padding-top: 15px;
    padding-left: 15px;
    padding-right: 15px;
    position: relative;
  }
  .form-select-f {
    position: relative;
  }
  .form-select-f .from-img img{
    position: absolute;
    top: 10px;
    left: 16px;
    width: 20px;
  }
  .form-select-f .from-img span{
    position: absolute;
    top: 11px;
    left: 43px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.6);
  }
  .form-select-t .to-img span{
    position: absolute;
    top: 17px;
    left: 43px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.6);
  }
  .form-select-t .to-img img{
    position: absolute;
    top: 16px;
    left: 17px;
    width: 20px;
  }
  .form-select-t {
    position: relative;
  }
  .custom-form .form-select-f .form-select-from {
    padding: 20px 0px 0px 15px;
    border: 1px solid #de5d0a;
    width: 100%;
    height: 70px;
    border-radius: 8px;
  }
  .custom-form .form-select-t .form-select-to {
    padding: 20px 0px 0px 15px;
    border: 1px solid #de5d0a;
    margin-top: 7px;
    width: 100%;
    height: 70px;
    border-radius: 8px;
  }
  .selectD {
    font-size: 20px;
    font-weight: 500;
    height: 37px;
    text-align: center;
    padding-top: 14px;
  }
  .list-data {
    padding: 15px 17px 0px 10px;
  }
  // Custom lib
  .van-tab__text--ellipsis {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    font-weight: 600;
    height: 30px;
  }
  .van-tabs__nav--line {
    box-sizing: content-box;
    height: 100%;
    padding-bottom: 15px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  .van-tab {
    position: relative;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-size: 13px !important;
    cursor: pointer;
  }
  .van-tab--active {
    color: #de5d0a !important;
  }
  .van-tabs__line {
    position: absolute;
    bottom: 15px;
    left: 0;
    z-index: 1;
    width: 80px !important;
    height: var(--van-tabs-bottom-bar-height);
    background: #de5d0a;
    border-radius: var(--van-tabs-bottom-bar-height);
  }
  // button search
  .van-search__field {
    flex: 1;
    padding: 10px var(--van-padding-xs) 10px 0;
    background-color: transparent;
  }
  .van-icon-cross:before {
    content: "\e6a7";
    position: fixed !important;
    right: 15px !important;
  }
  .van-tabbar-item--active {
    color: #de5d0a !important;
    background-color: var(--van-tabbar-item-active-background-color);
  }
  .animation {
    position: absolute !important;
    top: 73px !important;
    right: 40px !important;
    padding: 5px !important;
    font-weight: bold !important;
    font-size: 18px !important;
    border-radius: 100% !important;
    background: #de5d0a !important;
    color: #FFF !important;
    transition-duration: 0.5s;
  }
  .activeDeparture::after {
    content: '\2713';
    float: right;
    color: #50be1a;
    font-weight: bold;
  }
  .van-icon-glod:before {
    content: "\f57d" !important;
  }
  .custom-tab-bar {
    display: flex;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    position: fixed;
    bottom: 0;
    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;
  }
  .custom-tab-bar .home_page {
    width: 50%;
    text-align: center;
    color: #646566;
  }
  .custom-tab-bar .my_booking_page {
    width: 50%;
    text-align: center;
    color: #646566;
  }
</style>
